<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12 md2>
        <v-card>
          <v-card-title> Secretaría </v-card-title>
          <v-list dense class="pt-0">
            <v-list-tile
              v-for="item in secretaria"
              :key="item.title"
              @click="$router.push({ name: item.name })"
            >
              <!--<v-list-tile v-for="item in secretaria" :key="item.title" @click="$router.replace(item.name)">-->
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title
                  :style="{
                    'font-weight': $route.name === item.name ? 'bold' : '',
                  }"
                  >{{ item.text }}</v-list-tile-title
                >
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>

        <br />

        <v-card>
          <v-card-title> Unidades </v-card-title>
          <v-list dense class="pt-0">
            <!--<v-list-tile v-for="item in items" :key="item.title" @click="$router.push({name: item.name})">-->
            <!--<v-list-tile v-for="item in items" :key="item.title" @click="$router.push(item.name)">-->
            <v-list-tile
              v-for="item in items"
              :key="item.name"
              @click="
                $router.push({
                  name: 'listados',
                  params: { unidad: item.name },
                })
              "
            >
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title
                  :style="{
                    'font-weight': $route.name === item.name ? 'bold' : '',
                  }"
                  >{{ item.text }}</v-list-tile-title
                >
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
      <v-flex xs12 md10>
        <router-view>
          <v-container fluid grid-list-xl>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-card>
                  <v-card-title
                    >Reservas <h style="font-size: 200%"> 344</h></v-card-title
                  >
                </v-card>
              </v-flex>
              <v-flex xs12 md6> </v-flex>
            </v-layout>
          </v-container>
        </router-view>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Campamentos from "./campamento/Campamentos";

export default {
  components: { Campamentos },
  data: () => ({
    dialog: false,
    drawer: null,
    /*
            items: [
                { icon: 'history', text: 'Reservas', name: ''},
                { icon: 'person', text: 'Listados', name: 'listados/Fenix'},
                { icon: 'person', text: 'Unidad', name: 'listados'},
               // { icon: 'history', text: 'Cuotas' },
               // { icon: 'content_copy', text: 'Asistencia' }
            ],
            */
    secretaria: [
      { icon: "history", text: "Sin revisar", name: "secretaria" },
      { icon: "history", text: "Sin pagar", name: "unpaided" },
      //{ icon: "history", text: "Futuro", name: "unrevised" },
      { icon: "history", text: "Datos OLD", name: "secreto" },
      { icon: "history", text: "Dia de Familias", name: "diafamilias" },
      //{ icon: "history", text: "Datos", name: "datos" },
      { icon: "history", text: "Todos", name: "pagados" },//Aparece como Todos, pero se prevee crear una pestana de Pagados
    ],
    unidades: [],
  }),
  firestore() {
    return {
      unidades: this.$db.collection("unidades").orderBy("orden"),
    };
  },
  props: {
    source: String,
  },
  computed: {
    items() {
      var futuro_items = [];

      //Anadir unidades
      for (var unidad in this.unidades) {
        var id_unidades = this.unidades[unidad].id;
        futuro_items.push({
          icon: "person",
          text: id_unidades,
          //name: '/secretaria/listados/' + id_unidades
          name: id_unidades,
        });
      }

      return futuro_items;
    },
  },
};
</script>

<style scoped>
</style>